//import ScrollMagic from 'scrollmagic';

import * as ScrollMagic from 'scrollmagic';
import { gsap } from 'gsap';
import {TimelineMax, Power3, TweenMax} from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
ScrollMagicPluginGsap(ScrollMagic, gsap);

export default {
  init() {
    // JavaScript to be fired on pages that use the alternating section layout
    $(document).ready(function () {
      var tween = new TimelineMax();
      var controller,
        scrollHeader,
        stackIncrement,
        pageHeight,
        topVal,
        topVal2;

      function sceneSet() {
        stackIncrement = 70;
        scrollHeader = $('#scrollHeader').innerHeight();
        pageHeight = $('#page-1').innerHeight();
        topVal = stackIncrement + scrollHeader - pageHeight;
        topVal2 = stackIncrement + scrollHeader + stackIncrement - pageHeight;

        controller = new ScrollMagic.Controller();

        if($(window).width() > 960) {
          $('#scroll-track #scrollHeader').removeAttr('uk-sticky')

          tween.fromTo(
            '#page-1',
            2.5,
            {top: scrollHeader},
            {top: topVal, ease: Power3.easeInOut},
            '+=1'
          )
            .fromTo(
            '#page-2',
            2.5,
            {top: scrollHeader + stackIncrement},
            {top: topVal2, ease: Power3.easeInOut},
            '+=1'
          );

          new ScrollMagic.Scene({
            triggerElement: '#scroll-track',
            triggerHook: 'onLeave',
            offset: -70,
            duration: '100%',
          })
            .setPin('#scroll-track', {pushFollowers: true}) // pins the element for the the scene's duration
            .setTween(tween)
            .addTo(controller);
        } else {
            $('#scroll-track #scrollHeader').attr('uk-sticky', 'bottom: #page-2; end: #page-2; offset: 70px; overflow-flip: true')
        }
      }

      // referenced codepen - https://codepen.io/PointC/pen/xBdBrz
      function sceneUpdate() {
        tween.clear();
        controller.destroy(true)
        sceneSet();
      }

      window.addEventListener('resize', sceneUpdate);

      // Page load init
      sceneSet();
    })
  },
  finalize() {
    // JavaScript to be fired on pages that use the alternating section layout, after the init JS
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/scrollSwiping.js